<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>business</mat-icon></div>
          <mat-card-title>Departamentos</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          [showSituacao]="true"
          [(situacao)]="situacao"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Clique em <strong>Consultar</strong> para listar os departamentos.
        </div>

        <table *ngIf="consultaRealizada" mat-table [dataSource]="departamentos" class="full-width">
          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef>Nome</th>
            <td mat-cell *matCellDef="let d">{{ d.nome }}</td>
          </ng-container>
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td mat-cell *matCellDef="let d">{{ d.descricao || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="ativa">
            <th mat-header-cell *matHeaderCellDef>Situação</th>
            <td mat-cell *matCellDef="let d">{{ d.ativo !== false ? 'Ativo' : 'Inativo' }}</td>
          </ng-container>
          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let d" (click)="$event.stopPropagation()">
              <button mat-icon-button color="accent" matTooltip="Alterar" (click)="editar(d)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Inativar" (click)="inativar(d)" *ngIf="d.ativo !== false">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['nome','descricao','ativa','acoes']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['nome','descricao','ativa','acoes'];"
            class="wow-consulta__row" (click)="editar(row)"></tr>
        </table>
      </mat-card>
    </div>
  </div>
</main>
